import { useLiveQuery } from "dexie-react-hooks";
import { useEffect, useMemo, useState } from "react";
import { db } from "~/db/db";
import { useGetVendedores } from "~components/Request/useRequestQuery";
import useUsuario from "~/fetchs/useUsuario";

const chaveVendedor = "vendedor-selecionado-id";

const useVendedor = () => {
  const [modalSyncAlert, setModalSyncAlert] = useState(false);
  const [pendingVendedorChange, setPendingVendedorChange] = useState(null);
  const { usuario } = useUsuario();
  const hasSyncBySellerAccess = Boolean(usuario?.slugAcessos?.includes("sincronismo-por-vendedor"));
  const vendedorSelecionado = useLiveQuery(async () => {
    const vendedorSel = await db.vendedorSelecionado.toCollection().first();
    return vendedorSel?.id ?? null;
  }, []);
  const isVendedorReady = !hasSyncBySellerAccess || vendedorSelecionado !== undefined;

  const vendedores = useLiveQuery(() => db.vendedores.toArray(), []);
  const clientesSelecionados = useLiveQuery(async () => {
    if (vendedorSelecionado) {
      const result = [];

      await db.cliente
        .filter(x => x.usuarioId == vendedorSelecionado)
        .each((item) => result.push(item.id));

      return result;
    }

    return false;
  }, [vendedorSelecionado]);

  const optionsVendedores = useMemo(() => {
    const vendedoresOrdenados = (vendedores ?? [])
      .slice()
      .sort((a, b) => (a?.nome ?? "").localeCompare(b?.nome ?? "", "pt-BR", { sensitivity: "base" }));

    const vendedoresArray = [{ id: null, nome: "VISÃO GERAL" }, ...vendedoresOrdenados];

    return vendedoresArray.map((vendedor) => ({
      value: vendedor.id,
      label: vendedor.nome,
    }));
  }, [vendedores]);

  const [enableFetchVendedores, setEnableFetchVendedores] = useState(false);
  const { data: dadosVendedores } = useGetVendedores(enableFetchVendedores);


  useEffect(() => {
    const syncVendedores = async () => {
      if (!Array.isArray(dadosVendedores?.data)) {
        return;
      }

      await db.transaction("rw", db.vendedores, async () => {
        await db.vendedores.clear();

        if (dadosVendedores.data.length) {
          await db.vendedores.bulkPut(dadosVendedores.data);
        }
      });
    };

    syncVendedores();
  }, [dadosVendedores]);

  useEffect(() => {
    setEnableFetchVendedores(true);
  }, []);

  const updateVendedorSelecionado = async (vendedorId) => {
    await db.transaction("rw", db.vendedorSelecionado, async () => {
      if (vendedorId === null) {
        await db.vendedorSelecionado.clear();
        localStorage.removeItem(chaveVendedor);
        return;
      }

      await db.vendedorSelecionado.put({ id: vendedorId });
      await db.vendedorSelecionado.where("id").notEqual(vendedorId).delete();
      localStorage.setItem(chaveVendedor, String(vendedorId));
    });
  };

  const onChangeVendedor = async (e) => {
    const vendedorId = e?.value ?? null;

    if (vendedorId === vendedorSelecionado) {
      return;
    }

    if (!hasSyncBySellerAccess) {
      await updateVendedorSelecionado(vendedorId);
      return;
    }

    setPendingVendedorChange(vendedorId);
    setModalSyncAlert(hasSyncBySellerAccess);
  };

  const confirmVendedorChange = async () => {
    console.log("Confirmando mudança de vendedor para:", pendingVendedorChange);
    if (!hasSyncBySellerAccess) {
      return;
    }

      await updateVendedorSelecionado(pendingVendedorChange);
      setPendingVendedorChange(null);
      setModalSyncAlert(false);


      if ("caches" in globalThis) {
        const cacheNames = await caches.keys();
        for (const cacheName of cacheNames) {
          await caches.delete(cacheName);
        }
      }
      localStorage.setItem("shouldSyncronize", "true");
      globalThis.location.reload({ reload: true });
  };

  const cancelVendedorChange = () => {
    setPendingVendedorChange(null);
    setModalSyncAlert(false);
  };


  const vendedorId = hasSyncBySellerAccess ? vendedorSelecionado : null;

  return {
    vendedores,
    clientesSelecionados,
    vendedorSelecionado,
    optionsVendedores,
    onChangeVendedor,
    vendedorId,
    hasSyncBySellerAccess,
    isVendedorReady,
    modalSyncAlert: hasSyncBySellerAccess ? modalSyncAlert : false,
    confirmVendedorChange,
    cancelVendedorChange
  };
};

export default useVendedor
